import React from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../App";
import useInvoke from "../Tools/Invoker";
import DynamicGrid from "../Tools/DynamicGrid";
import LoginRedirect from "../Page/LoginRedirect";
import CheckToken from "../_Login/CheckToken";
import toast, { Toaster } from 'react-hot-toast';
import CompassBanner from "../Tools/CompassBanner";
import { Chart, registerables } from "chart.js"
import { LineChart, Line, XAxis, YAxis, ZAxis, CartesianGrid, Tooltip, Legend, Label, Scatter, ScatterChart, ResponsiveContainer, ReferenceLine } from 'recharts';
import { parse } from "popper/farms/saucelabs";
import CompassLogo from "../Tools/CompassLogo";

const EductorPrint = () => {

    const { id } = useParams();
    const [user, setUser] = useContext(UserContext);
    let navigate = useNavigate();
    CheckToken(user["id"], user["token"]).then((result) => { if (!result) { localStorage.clear(); setUser({}); navigate("/Login") } });

    //get eductor data
    let response76 = useInvoke("Eductor", "76", { "eductorID": id });

    //get users
    let response64 = useInvoke("WebApps", "64", {});

    //get tests
    let response75 = useInvoke("Eductor", "75", { "eductorID": id });

    const [eductor, setEductor] = useState({});
    const [users, setUsers] = useState([]);
    const [tests, setTests] = useState([]);

    const calcInnerDiameter = (diameter, thickness) => {
        if (!diameter || !thickness) return 0;
        const thicknessMap = {
            "1/32": 1 / 32,
            "1/16": 1 / 16,
            "1/8": 1 / 8,
            "3/16": 3 / 16,
            "1/4": 1 / 4,
            "1/2": 1 / 2
        };
        const t = thicknessMap[thickness];
        return t ? parseFloat(diameter) - (2 * t) : 0;
    };

    const calcArea = (innerDiameter) => {
        return parseFloat((innerDiameter * 0.5) ** 2 * Math.PI / 144);
    };


    useEffect(() => {

        if (response76.data.payload != undefined) {

            let data = JSON.parse(response76.data.payload).data[0];

            let datecompleted = "";
            let bspr_datecompleted = "";

            const parts5 = data[5].split('/');
            const parts23 = data[23].split('/');

            if (parts5.length > 1) {
                datecompleted = new Date(parts5[2], parts5[0] - 1, parts5[1]).toISOString().split('T')[0];
            }

            if (parts23.length > 1) {
                bspr_datecompleted = new Date(parts23[2], parts23[0] - 1, parts23[1]).toISOString().split('T')[0];
            }


            let obj = {
                "id": data[0],
                "jobnumber": data[1],
                "quotenumber": data[2],
                "model": data[3],
                "datecreated": data[4],
                "datecompleted": datecompleted.replace(/(\d{4})-(\d{2})-(\d{2})/, '$2/$3/$1'), //2023-06-07 => 06/07/2023
                "testedbyid": data[6],
                "approvedbyid": data[7],
                "sketchnumber": data[8],
                "frequency": data[9],
                "inletdiameter": data[10],
                "outletdiameter": data[11],
                "horsepower": data[12],
                "velocity": data[13],
                "cspr_inducedairflow": parseFloat(data[14]).toFixed(0),
                "cspr_inletstaticpressure": parseFloat(data[15]).toFixed(2),
                "cspr_dischargestaticpressure": parseFloat(data[16]).toFixed(2),
                "bspr_manufacturermodel": data[17],
                "bspr_airflowcfm": parseFloat(data[18]).toFixed(0),
                "bspr_calculatedbhp": parseFloat(data[19]).toFixed(1),
                "bspr_inletstaticpressure": parseFloat(data[20]).toFixed(2),
                "bspr_outletstaticpressure": parseFloat(data[21]).toFixed(2),
                "bspr_purchaseordernumber": data[22],
                "bspr_datecompleted": bspr_datecompleted.replace(/(\d{4})-(\d{2})-(\d{2})/, '$2/$3/$1'), //2023-06-07 => 06/07/2023,
                "apr_plenumpressure": parseFloat(data[24]).toFixed(2),
                "apr_nozzlesetting": data[25],
                "apr_staticclosedoff": parseFloat(data[26]).toFixed(2),
                "apr_tight": data[27],
                "apr_motorrpm": parseFloat(data[28]).toFixed(0),
                "apr_motorvoltage": parseFloat(data[29]).toFixed(0),
                "apr_calculatedblowerairflow": parseFloat(data[30]).toFixed(0),
                "apr_plenumtype": data[31],
                "apr_motoramps1": parseFloat(data[32]).toFixed(2),
                "apr_motoramps2": parseFloat(data[33]).toFixed(2),
                "apr_motoramps3": parseFloat(data[34]).toFixed(2),
                "apr_motorampsaverage": parseFloat(data[35]).toFixed(2),
                "apr_motorampsrated": parseFloat(data[36]).toFixed(2),
                "notes": data[37],
                "customer": data[38],
                "air_temperature": parseFloat(data[39]).toFixed(2),
                "air_humidity": parseFloat(data[40]).toFixed(2),
                "air_pressure": parseFloat(data[41]).toFixed(2),
                "intakesilencer": data[42] == "False" ? 0 : 1,
                "suffix": data[44],
                "air_density": 0
            };

            let tempFahrenheit = obj["air_temperature"];
            let humidityPercentage = obj["air_humidity"];
            let pressureInchesMercury = obj["air_pressure"];

            let tempCelsius = ((parseFloat(tempFahrenheit) - 32) / 1.8);
            let tempKelvin = (parseFloat(tempFahrenheit) + (459.67)) * (5 / 9);

            let pressurePascals = parseFloat(pressureInchesMercury) * 3386.39;

            let vaporPressure = (parseFloat(humidityPercentage) / 100) * (6.105 ^ (17.27 * parseFloat(tempCelsius) / (parseFloat(tempCelsius) + 237.7)))

            let dryPressure = parseFloat(pressurePascals) - parseFloat(vaporPressure);

            let airDensityKilogramsMeterCubed = (parseFloat(dryPressure) / (287.058 * parseFloat(tempKelvin)));

            let airDensityLbFootCubed = 0.062428 * parseFloat(airDensityKilogramsMeterCubed);

            obj["air_density"] = parseFloat(airDensityLbFootCubed).toFixed(10);

            setEductor(obj);

        }

        //get user list
        if (response64.data.payload != undefined) {
            let data = JSON.parse(response64.data.payload).data;

            let userList = [];

            data.forEach((user, index) => {

                let obj = {
                    "id": user[0],
                    "firstname": user[1],
                    "lastname": user[2],
                    "email": user[3],
                    "mustchangepassword": user[4],
                    "role": user[5]
                };

                userList.push(obj);

            });

            setUsers(userList);

        }

    }, [response76.data.payload, response64.data.payload, response75.data.payload]);

    useEffect(() => {

        //re-render page

        //The segment below has been moved from initial useEffect to ensure that eductor state has been set
        //Before attempting to use eductor attributes for calculations in tests portion

        //get tests
        if (response75.data.payload != undefined) {
            let data = JSON.parse(response75.data.payload).data;

            let tempFahrenheit = eductor["air_temperature"];
            let humidityPercentage = eductor["air_humidity"];
            let pressureInchesMercury = eductor["air_pressure"];

            let tempCelsius = ((parseFloat(tempFahrenheit) - 32) / 1.8);
            let tempKelvin = (parseFloat(tempFahrenheit) + (459.67)) * (5 / 9);

            let pressurePascals = parseFloat(pressureInchesMercury) * 3386.39;

            let vaporPressure = (parseFloat(humidityPercentage) / 100) * (6.105 ^ (17.27 * parseFloat(tempCelsius) / (parseFloat(tempCelsius) + 237.7)))

            let dryPressure = parseFloat(pressurePascals) - parseFloat(vaporPressure);

            let airDensityKilogramsMeterCubed = (parseFloat(dryPressure) / (287.058 * parseFloat(tempKelvin)));

            let airDensityLbFootCubed = 0.062428 * parseFloat(airDensityKilogramsMeterCubed);

            let testList = [];

            data.forEach((test, index) => {

                let sum = 0;
                let avg = 0;
                let count = 0;

                let tests = [
                    Math.sqrt(parseFloat(test[8])),
                    Math.sqrt(parseFloat(test[9])),
                    Math.sqrt(parseFloat(test[10])),
                    Math.sqrt(parseFloat(test[11])),
                    Math.sqrt(parseFloat(test[12])),
                    Math.sqrt(parseFloat(test[13])),
                    Math.sqrt(parseFloat(test[14])),
                    Math.sqrt(parseFloat(test[15])),
                    Math.sqrt(parseFloat(test[16])),
                    Math.sqrt(parseFloat(test[17])),
                    Math.sqrt(parseFloat(test[18]))
                ];

                tests.forEach((test1, index) => {
                    if (test1 != 0) {
                        sum += test1;
                        count++;
                    }

                });

                avg = (count > 0 ? sum / count : 0).toFixed(2);

                //let velocity = (parseFloat(avg) / 0.2576) * 1096;

                let airDensityFactor = Math.sqrt(parseFloat(airDensityLbFootCubed));
                let velocity = (parseFloat(avg) / airDensityFactor) * 1096;

                const diameter = parseFloat(test[5]);
                const gauge = test[22];
                const innerDiameter = calcInnerDiameter(diameter, gauge);
                const area = calcArea(innerDiameter);
                const cfm = parseFloat(velocity) * area;

                let obj = {
                    "id": test[0],
                    // "eductorid": test[1],
                    "percentage": test[2],
                    "inletoutlet": test[3],
                    "blowerintake": test[4],
                    "diameter": parseFloat(test[5]).toFixed(3),
                    "area": parseFloat(area).toFixed(2),
                    "staticpressure": parseFloat(test[7]).toFixed(2),
                    "vp1": parseFloat(test[8]).toFixed(2),
                    "vp2": parseFloat(test[9]).toFixed(2),
                    "vp3": parseFloat(test[10]).toFixed(2),
                    "vp4": parseFloat(test[11]).toFixed(2),
                    "vp5": parseFloat(test[12]).toFixed(2),
                    "vp6": parseFloat(test[13]).toFixed(2),
                    "vp7": parseFloat(test[14]).toFixed(2),
                    "vp8": parseFloat(test[15]).toFixed(2),
                    "vp9": parseFloat(test[16]).toFixed(2),
                    "vp10": parseFloat(test[17]).toFixed(2),
                    "vp11": parseFloat(test[18]).toFixed(2),
                    "average": parseFloat(avg).toFixed(2),
                    "notes": test[19],
                    "datecreated": test[20],
                    "datemodified": test[21],
                    "velocity": parseFloat(velocity).toFixed(0),
                    "cfm": parseFloat(cfm).toFixed(0),
                    "gauge": test[22],
                    "innerDiameter": innerDiameter.toFixed(2),
                    "gauge": gauge,
                    "area": area.toFixed(3),
                    "cfm": cfm.toFixed(0),


                };

                testList.push(obj);


            });

            setTests(testList);


        }

    }, [eductor]);

    useEffect(() => {

        //re-render page

    }, [users]);

    useEffect(() => {

        //re-render page

    }, [tests]);

    const getToday = (e) => {

        const today = new Date();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        const year = String(today.getFullYear());

        return `${month}/${day}/${year}`;

    };

    const getFullNameById = (id) => {
        const user = users.find(user => user.id == id);

        if (user) {
            const { firstname, lastname } = user;
            return `${firstname} ${lastname}`;
        }

    }

    const handlePrint = () => {
        window.print();
    };

    const PerformanceGraph = (input) => {
        let breakpoint = "";
        let points = [];
        let graphPoints = [];
        let sortedPoints = [];
        let p = [];
        let r = [];
        let data01 = [];
        let data02 = [];

        if (input !== undefined && input["input"].length !== 0 && eductor["cspr_inducedairflow"] !== undefined) {
            input["input"].forEach((item, index) => {
                if (item["inletoutlet"] === "False" && item["percentage"] != 0) {

                    // points.push({ "x": item["cfm"], "y": Math.abs(parseFloat(item["staticpressure"])) });

                    points.push({ "x": parseFloat(item["cfm"]), "y": Math.abs(parseFloat(item["staticpressure"])) });

                }
            });


            sortedPoints = points.sort((a, b) => a.x - b.x);


            data01 = [
                { x: 0, y: Math.abs(parseFloat(eductor["apr_staticclosedoff"])) || 0 },
                { x: sortedPoints[0]?.x || 0, y: sortedPoints[0]?.y || 0 },
                { x: sortedPoints[1]?.x || 0, y: sortedPoints[1]?.y || 0 },
                { x: sortedPoints[2]?.x || 0, y: sortedPoints[2]?.y || 0 },
                { x: sortedPoints[3]?.x || 0, y: sortedPoints[3]?.y || 0 }
            ];

            data02 = [
                { x: parseFloat(eductor["cspr_inducedairflow"]), y: Math.abs(parseFloat(eductor["cspr_inletstaticpressure"])) + Math.abs(parseFloat(eductor["cspr_dischargestaticpressure"])) }
            ];
        };

        return (
            <div style={{ width: "100%", marginLeft: "30%" }}>
                <ResponsiveContainer width="33.3%" height={300}>
                    <ScatterChart
                        margin={{
                            top: 20,
                            right: 20,
                            bottom: 20,
                            left: 20,
                        }}
                    >
                        <CartesianGrid />
                        <XAxis type="number" dataKey="x" name="cfm" label={{ value: "CFM", position: "insideBottomRight", dy: 25, dx: 10 }} />
                        <YAxis type="number" dataKey="y" name="sp" label={{ value: "Static Pressure", position: "insideBottomRight", dy: -200, dx: -32, angle: -90 }} />
                        <ZAxis type="number" range={[100]} />
                        <Tooltip cursor={{ strokeDasharray: '3 3' }} />
                        <Legend />
                        <ReferenceLine x={parseFloat(eductor["cspr_inducedairflow"])} stroke="red" />
                        <ReferenceLine y={Math.abs(parseFloat(eductor["cspr_inletstaticpressure"])) + Math.abs(parseFloat(eductor["cspr_dischargestaticpressure"]))} stroke="red" />
                        <Scatter name="Tests" data={data01} fill="black" line shape="square" />
                        <Scatter name="Performance Req" data={data02} fill="red" line shape="cross" />



                    </ScatterChart>
                </ResponsiveContainer>
            </div>
        );
    };

    document.title = `Eductor - Print`;
    return (
        <>
            <div className="body-content" style={{ marginTop: "25px", width: "1100px", margin: "auto" }}>

                <div className="no-print" style={{ marginBottom: "8px" }}>
                    <Link to={`/Eductor/Details/${id}`} className="btn btn-default" style={{ width: "132px" }}>Back</Link>
                    <button onClick={handlePrint} className="btn btn-primary" style={{ width: "132px", marginLeft: "8px" }}>Print This Page</button>
                </div>

                <div style={{ border: "1px solid black", textAlign: "center", padding: "8px" }}>
                    {/* <CompassBanner /> */}
                    <CompassLogo />
                </div>

                <div style={{ color: "lightgray" }}>
                    <i>Report generated on {getToday()}</i>
                </div>

                <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>

                    <h3>Venturi Eductor Unit Performance Results</h3>
                    <span style={{ color: "red", fontWeight: "bold" }}><i>[CONFIDENTIAL]</i></span>

                </div>

                <div>
                    <table className="no-break" style={{ border: "1px solid black", width: "100%", marginTop: "16px", marginTop: "24px" }}>

                        <tr style={{ border: "1px solid black", width: "100%", display: "flex", flexDirection: "row" }}>
                            <td style={{ border: "1px solid black", padding: "8px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}><span style={{ fontWeight: "bold" }}>Eductor Model Name: </span><span style={{ marginLeft: "8px" }}>{eductor["model"]}</span></td>
                        </tr>

                        <tr style={{ border: "1px solid black", width: "100%", display: "flex", flexDirection: "row" }}>
                            <td style={{ border: "1px solid black", padding: "8px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}><span style={{ fontWeight: "bold" }}>Model (Ext.): </span><span style={{ marginLeft: "8px" }}>{eductor["suffix"]}</span></td>
                        </tr>

                        <tr style={{ border: "1px solid black", width: "100%", display: "flex", flexDirection: "row" }}>
                            <td style={{ border: "1px solid black", padding: "8px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}><span style={{ fontWeight: "bold" }}>Fan Model Name: </span><span style={{ marginLeft: "8px" }}>{eductor["bspr_manufacturermodel"]}</span></td>
                        </tr>

                        <tr style={{ border: "1px solid black", width: "100%", display: "flex", flexDirection: "row" }}>
                            <td style={{ border: "1px solid black", padding: "8px", width: "50%", display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}><span style={{ fontWeight: "bold" }}>Job Number: </span><span style={{ marginLeft: "8px" }}>{eductor["jobnumber"]}</span></td>
                            <td style={{ border: "1px solid black", padding: "8px", width: "50%", display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}><span style={{ fontWeight: "bold" }}>Date Completed: </span><span style={{ marginLeft: "8px" }}>{eductor["datecompleted"]}</span></td>
                        </tr>

                        <tr style={{ border: "1px solid black", width: "100%", display: "flex", flexDirection: "row" }}>
                            <td style={{ border: "1px solid black", padding: "8px", width: "33.4%", display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}><span style={{ fontWeight: "bold" }}>Customer Name: </span><span style={{ marginLeft: "8px" }}>{eductor["customer"]}</span></td>
                            <td style={{ border: "1px solid black", padding: "8px", width: "33.4%", display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}><span style={{ fontWeight: "bold" }}>Quote Number: </span><span style={{ marginLeft: "8px" }}>{eductor["quotenumber"]}</span></td>
                            <td style={{ border: "1px solid black", padding: "8px", width: "33.4%", display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}><span style={{ fontWeight: "bold" }}>Sketch Number: </span><span style={{ marginLeft: "8px" }}>{eductor["sketchnumber"]}</span></td>
                        </tr>

                    </table>
                </div>

                <div className="no-break" style={{ border: "2px solid black", textAlign: "left", padding: "4px", marginTop: "24px" }}>

                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "center", gap: "8px" }}>
                        <h5 style={{ textDecoration: "underline", marginLeft: "8px", fontWeight: "bold" }}>CALCULATED SYSTEM PERFORMANCE</h5>
                        <i style={{ opacity: "0.5" }}>(FROM DESIGN CONFIGURATOR SYSTEM DESIGN SHEET)</i>
                    </div>

                    <div style={{ textAlign: "left", padding: "4px", display: "flex", flexDirection: "row", margin: "auto", justifyContent: "space-between" }}>

                        <ol style={{ marginRight: "16px" }}>
                            <li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>INDUCED AIRFLOW: </span><span style={{ marginLeft: "8px" }}>{eductor["cspr_inducedairflow"]}</span></li>
                        </ol>

                        <ol style={{ marginRight: "16px" }}>
                            <li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>INLET STATIC PRESSURE: </span><span style={{ marginLeft: "8px" }}>{eductor["cspr_inletstaticpressure"]}</span></li>
                        </ol>

                        <ol style={{ marginRight: "16px" }}>
                            <li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>DISCHARGE STATIC PRESSURE: </span><span style={{ marginLeft: "8px" }}>{eductor["cspr_dischargestaticpressure"]}</span></li>
                        </ol>

                    </div>
                </div>

                <div className="no-break" style={{ border: "2px solid black", textAlign: "left", padding: "4px" }}>

                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "center", gap: "8px" }}>
                        <h5 style={{ textDecoration: "underline", marginLeft: "8px", fontWeight: "bold" }}>BLOWER SELECTION PERFORMANCE REQUIREMENTS</h5>
                        <i style={{ opacity: "0.5" }}>(FROM BLOWER VENDOR PERFORMANCE SHEETS OR QUOTE)</i>
                    </div>

                    <div style={{ textAlign: "left", padding: "4px", display: "flex", flexDirection: "row", margin: "auto", justifyContent: "space-between" }}>

                        <ol style={{ marginRight: "16px" }}>
                            <li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>AIRFLOW (ACFM): </span><span style={{ marginLeft: "8px" }}>{eductor["bspr_airflowcfm"]}</span></li>
                            <li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>INTERNAL PO NUMBER: </span><span style={{ marginLeft: "8px" }}>{eductor["bspr_purchaseordernumber"]}</span></li>
                        </ol>

                        <ol style={{ marginRight: "16px" }}>
                            <li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>INLET STATIC PRESSURE: </span><span style={{ marginLeft: "8px" }}>{eductor["bspr_inletstaticpressure"]}</span></li>
                            <li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>CALCULATED BHP: </span><span style={{ marginLeft: "8px" }}>{eductor["bspr_calculatedbhp"]}</span></li>
                        </ol>

                        <ol style={{ marginRight: "16px" }}>
                            <li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>DISCHARGE STATIC PRESSURE: </span><span style={{ marginLeft: "8px" }}>{eductor["bspr_outletstaticpressure"]}</span></li>
                            <li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>DATE COMPLETED: </span><span style={{ marginLeft: "8px" }}>{eductor["bspr_datecompleted"]}</span></li>
                        </ol>

                    </div>
                </div>

                <div className="no-break" style={{ border: "2px solid black", textAlign: "left", padding: "4px" }}>
                    <h5 style={{ textDecoration: "underline", marginLeft: "8px", fontWeight: "bold" }}>ACTUAL PERFORMANCE RESULTS</h5>
                    <div style={{ textAlign: "left", padding: "4px", display: "flex", flexDirection: "row", margin: "auto", justifyContent: "space-between" }}>

                        <ol style={{ marginRight: "16px" }}>
                            <li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>ACTUAL PLENUM PRESSURE: </span><span style={{ marginLeft: "8px" }}>{eductor["apr_plenumpressure"]}</span></li>
                            <li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>STATIC CLOSED OFF: </span><span style={{ marginLeft: "8px" }}>{eductor["apr_staticclosedoff"]}</span></li>
                            <li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>MOTOR RPM: </span><span style={{ marginLeft: "8px" }}>{eductor["apr_motorrpm"]}</span></li>
                            <li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>CALCULATED BLOWER AIR FLOW: </span><span style={{ marginLeft: "8px" }}>{eductor["apr_calculatedblowerairflow"]}</span></li>
                        </ol>

                        <ol style={{ marginRight: "16px" }}>
                            <li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>PLENUM TYPE: </span><span style={{ marginLeft: "8px" }}>{eductor["apr_plenumtype"]}</span></li>
                            <li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>NOZZLE SETTING: </span><span style={{ marginLeft: "8px" }}>{eductor["apr_nozzlesetting"]}"</span></li>
                            <li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>TIGHT / LOOSE: </span><span style={{ marginLeft: "8px" }}>{eductor["apr_tight"]}</span></li>
                            <li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>MOTOR VOLTAGE: </span><span style={{ marginLeft: "8px" }}>{eductor["apr_motorvoltage"]}</span></li>
                            <li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>INTAKE SILENCER: </span><span style={{ marginLeft: "8px" }}>{eductor["intakesilencer"] == 1 ? 'Yes' : 'No'}</span></li>

                        </ol>

                        <ol style={{ marginRight: "16px" }}>
                            <li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>MOTOR AMPS 1: </span><span style={{ marginLeft: "8px" }}>{eductor["apr_motoramps1"]}</span></li>
                            <li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>MOTOR AMPS 2: </span><span style={{ marginLeft: "8px" }}>{eductor["apr_motoramps2"]}</span></li>
                            <li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>MOTOR AMPS 3: </span><span style={{ marginLeft: "8px" }}>{eductor["apr_motoramps3"]}</span></li>
                            <li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>MOTOR AMPS AVG: </span><span style={{ marginLeft: "8px" }}>{eductor["apr_motorampsaverage"]}</span></li>
                            <li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>MOTOR AMP RATING: </span><span style={{ marginLeft: "8px" }}>{eductor["apr_motorampsrated"]}</span></li>

                        </ol>

                    </div>

                </div>

                <div className="no-break" style={{ border: "2px solid black", textAlign: "left", padding: "4px" }}>
                    <h5 style={{ textDecoration: "underline", marginLeft: "8px", fontWeight: "bold" }}>AIR PROPERTIES DURING TEST</h5>
                    <div style={{ textAlign: "left", padding: "4px", display: "flex", flexDirection: "row", margin: "auto", justifyContent: "space-between" }}>

                        <ol style={{ marginRight: "16px" }}>
                            <li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>AIR TEMPERATURE (°F): </span><span style={{ marginLeft: "8px" }}>{eductor["air_temperature"]}</span></li>
                        </ol>

                        <ol style={{ marginRight: "16px" }}>
                            <li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>HUMIDITY (%): </span><span style={{ marginLeft: "8px" }}>{eductor["air_humidity"]}</span></li>
                        </ol>

                        <ol style={{ marginRight: "16px" }}>
                            <li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>AIR PRESSURE (inHg): </span><span style={{ marginLeft: "8px" }}>{eductor["air_pressure"]}</span></li>
                        </ol>

                        <ol style={{ marginRight: "16px" }}>
                            <li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>AIR DENSITY (lb/ft³): </span><span style={{ marginLeft: "8px" }}>{eductor["air_density"]}</span></li>
                        </ol>

                    </div>

                </div>

                <div className="no-break" style={{ border: "2px solid black", textAlign: "left", padding: "4px" }}>
                    <h5 style={{ textDecoration: "underline", marginLeft: "8px", fontWeight: "bold" }}>NOTES</h5>
                    <div style={{ padding: "8px 16px" }}>
                        {eductor["notes"]?.split('\n').map((line, index) => (
                            <React.Fragment key={index}>
                                {line}
                                <br />
                            </React.Fragment>
                        ))}
                    </div>

                </div>


                {tests &&
                    tests.map((test, index) => (
                        <div key={index}>

                            <table className="no-break" style={{ border: "1px solid black", width: "100%", marginTop: "16px", marginTop: "24px" }}>
                                <tbody>
                                    <tr style={{ width: "100%", display: "flex", flexDirection: "row" }}>
                                        <td style={{ border: "1px solid black", padding: "8px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-evenly", fontWeight: "bold", textDecoration: "underline" }}>
                                            TEST# {index === 9 ? '5B - Blower Air' : (index === 8 ? '5A - Blower Air' : `${Math.floor(index / 2) + 1}${index % 2 === 0 ? 'A - Inlet' : 'B - Outlet'}`)}
                                        </td>

                                        <td style={{ border: "1px solid black", padding: "8px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}>{test["percentage"]}% Open</td>
                                        <td style={{ border: "1px solid black", padding: "8px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}>{test["diameter"]}" Diameter</td>
                                        <td style={{ border: "1px solid black", padding: "8px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}>{test["innerDiameter"]}" Inner Diameter</td>
                                        <td style={{ border: "1px solid black", padding: "8px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}>{test["gauge"]}" Thick</td>
                                        <td style={{ border: "1px solid black", padding: "8px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}>{test["area"]}" Area (intake side)</td>
                                    </tr>

                                    <tr style={{ width: "100%", display: "flex", flexDirection: "row" }}>
                                        <td style={{ border: "1px solid black", padding: "8px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}>Static Pressure: {test["staticpressure"]} H₂O</td>
                                        <td style={{ border: "1px solid black", padding: "8px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}>Avg√VP: {test["average"]}</td>
                                        <td style={{ border: "1px solid black", padding: "8px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}>Velocity: {test["velocity"]} FPM</td>
                                        <td style={{ border: "1px solid black", padding: "8px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}>CFM: {test["cfm"]}</td>
                                    </tr>

                                    <tr style={{ width: "100%", display: "flex", flexDirection: "row" }}>
                                        {[...Array(11)].map((_, i) => (
                                            <td style={{ border: "1px solid black", padding: "8px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between", fontWeight: "bold" }} key={i}>
                                                <span>{`VP${i + 1}`}:</span> <span>{test[`vp${i + 1}`]}</span>
                                            </td>
                                        ))}
                                    </tr>

                                    <tr style={{ width: "100%", display: "flex", flexDirection: "row" }}>
                                        <td style={{ border: "1px solid black", padding: "8px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "flex-start" }}>Notes: {test["notes"]}</td>
                                    </tr>

                                </tbody>
                            </table>

                        </div>
                    ))
                }

                {tests !== undefined && tests.length > 0 &&
                    <>
                        <div className="card border-secondary mb-3 no-break" style={{ fontSize: "18px", fontWeight: "bold", marginTop: "24px" }}>

                            <h5 style={{ textDecoration: "underline", marginLeft: "8px", fontWeight: "bold" }}>PERFORMANCE CURVE</h5>

                            <PerformanceGraph input={tests} />

                        </div>
                    </>
                }

                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-evenly", marginTop: "24px" }}>
                    <h5><i>Test Approved By: {getFullNameById(eductor["approvedbyid"])}</i></h5>
                    <h5><i>Test Completed By: {getFullNameById(eductor["testedbyid"])}</i></h5>
                    <h5><i>Date Completed: {eductor["datecompleted"]}</i></h5>
                </div>

            </div>

        </>
    );
}

export default EductorPrint;